// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unit_group {\n  border-style: solid;\n  border-color: #adadad;\n  border-radius: 0.4rem;\n  border-width: thin;\n  padding: 10px;\n  max-width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
